export default __webpack_public_path__ + "static/media/107t.f2f7bb26.jpg";